const rootUrl="";
const basketFloatDelay=2000;
const basketFloatWidth=320;
const basketFloatzIndex=1010;
const defaultMaxItemWith=180;
const productItemWith=236;
const articleItemWidth=335;
const sliderMaxItems=30;
const sliderViewportWSwitch=600;
const paymentCheckTimeout=100;
const ARTICLE_LINK='fakta-och-rad';
const contentCatScrollDelay=500;
const contentViewportDeviationForFloating=150;
const contentFloatNumofBoxes=2;
const contentProductBoxHeight=317; // including 6px margin bottom
const hideTxtBarAtPos=30;
const deviceWidthToHideTxtBar=768;
const isClosePopupWhenScroll=true;
const txtBarMaxHeight=40;
const lazyLoadProdImg=true;
const lazyLoadCntImg=true;
const Flag = {
  GREEN: 1,
  YELLOW: 2,
  RED: 3
};
const ganBots=[
  "SemrushBot",
  "Googlebot",
  "facebookexternalhit",
  "bingbot",
  "Pingdom.com_bot"
]
const ganDeniedList=["/"];

function touchEnabled(){
  return navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/gi)?true:false;
}

export {
  rootUrl,
  basketFloatDelay,
  basketFloatWidth,
  basketFloatzIndex,
  paymentCheckTimeout,
  ARTICLE_LINK,
  contentCatScrollDelay,
  contentViewportDeviationForFloating,
  contentFloatNumofBoxes,
  defaultMaxItemWith,
  productItemWith,
  sliderMaxItems,
  touchEnabled,
  sliderViewportWSwitch,
  articleItemWidth,
  contentProductBoxHeight,
  hideTxtBarAtPos,
  deviceWidthToHideTxtBar,
  isClosePopupWhenScroll,
  txtBarMaxHeight,
  Flag,
  lazyLoadProdImg,
  lazyLoadCntImg,
  ganBots,
  ganDeniedList
};
